import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  getAuth,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
  getIdToken,
  updateProfile
} from "firebase/auth";
import {
  getFirestore,
  doc,
  setDoc,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getMessaging} from "firebase/messaging";

// Configuración e inicialización de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBsvU7zbAfWtMuYV9v1yqv0O4uqynT4rno",
  authDomain: "intellichallenge-7d25c.firebaseapp.com",
  projectId: "intellichallenge-7d25c",
  storageBucket: "intellichallenge-7d25c.appspot.com",
  messagingSenderId: "635537903306",
  appId: "1:635537903306:web:116df0733c2c9b336cee33",
  measurementId: "G-RBZMKLKTD1"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const messaging = getMessaging(app);

export { app, db, auth, storage, messaging };


export async function saveTokenToFirestore(token) {
  const userId = auth.currentUser ? auth.currentUser.uid : null;

  if (!userId) {
    console.error("Usuario no autenticado");
    return;
  }

  const userRef = doc(db, "users", userId);

  try {
    await setDoc(userRef, { fcmToken: token }, { merge: true });
    console.log("Token FCM guardado en Firestore con éxito");
  } catch (error) {
    console.error("Error al guardar el token FCM en Firestore:", error);
  }
}

// Funciones adicionales relacionadas con la autenticación y la gestión de usuarios

export const getToken = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      if (user) {
        getIdToken(user).then(
          (idToken) => {
            resolve(idToken);
          },
          (error) => {
            resolve(null);
          }
        );
      } else {
        resolve(null);
      }
    });
  });
};

export const signInUser = (email, password) => {
  return setPersistence(auth, browserLocalPersistence)
    .then(() => {
      return signInWithEmailAndPassword(auth, email, password);
    })
    .catch((error) => {
      console.error(error.code, error.message);
      throw error;
    });
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    console.log("¡Correo de restablecimiento de contraseña enviado correctamente!");
  } catch (error) {
    throw new Error("Error al enviar el correo de restablecimiento: " + error.message);
  }
};

export const createUser = async (
  email,
  password,
  displayName,
  phone,
  point,
) => {
  try {
    // Crear el usuario en Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCredential.user;
    const uid = user.uid;

    // Actualizar el perfil del usuario en Firebase Auth
    await updateProfile(user, {
      displayName: displayName
    });

    // Crear el documento del usuario en Firestore
    const userRef = doc(db, "users", uid);
    await setDoc(userRef, {
      uid,
      email,
      displayName,
      phone,
      point,
      profileImageUrl: "https://firebasestorage.googleapis.com/v0/b/intellichallenge-7d25c.appspot.com/o/user.png?alt=media&token=6dfbd95a-8f4f-4357-ab4c-3f38db121f5b",
    });

    return userCredential;
  } catch (error) {
    console.error("Error en createUser:", error);
    throw error;
  }
};

export const updateUser = async (uid, displayName, phone, point) => {
  try {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, {
      displayName,
      phone,
      point,
    });
    const userData = await getDoc(userRef);
    if (userData.exists()) {
      return { uid, ...userData.data() };
    } else {
      throw new Error("El usuario no existe");
    }
  } catch (error) {
    throw error;
  }
};

export const uploadImage = async (file) => {
  try {
    const randomId = Math.random().toString(36).substr(2, 9);
    const storageRef = ref(storage, `images/${randomId}-${file.name}`);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  } catch (error) {
    throw error;
  }
};

export const updateUserProfile = async (uid, profileData) => {
  try {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, profileData);
    console.log("Perfil del usuario actualizado correctamente.");
  } catch (error) {
    console.error("Error al actualizar el perfil del usuario:", error);
    throw error;
  }
};
